import ExerciseListItem from "@/components/molecules/Exercises/ExerciseListItem";
import React from "react";
import { usePagination } from "src/contexts/PaginationContext";

const StackedList: React.FC = () => {
  const { data, isSuccess } = usePagination();
  if (!isSuccess) return <div>Loading</div>;
  return (
    <div className="overflow-hidden bg-white shadow sm:rounded-md">
      <ul role="list" className="divide-y divide-gray-200">
        {data.map((exercise) => (
          <ExerciseListItem key={exercise.id} exercise={exercise} />
        ))}
      </ul>
    </div>
  );
};

export default StackedList;
